<section id="aboutme">
<div class="content">
    <div class="aboutmeleft">
        <h2>{{text.header}}</h2>
        <span>{{text.intro}}</span>
        <div class="icontext">
            <img src="assets/icons/bulp desktop.png" alt="" />
            <span>{{text.creative}}</span>
        </div>
        <div class="icontext">
            <img src="assets/icons/puzzle desktop.png" alt="" />
            <span>{{text.logical}}</span>
        </div>
    </div>
    <div class="aboutmeright">
        <img src="/assets/images/HP Foto.png" alt="">
        <div class="blueline"></div>
    </div>
</div>
</section>